import React from 'react';
import ReactDOM from 'react-dom/client';
import './Global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { MsalProvider } from "@azure/msal-react";
import { Configuration,  PublicClientApplication } from "@azure/msal-browser";
import ThemeComponent from './components/theme/ThemeComponent';

const configuration: Configuration = {    
    auth: {
	    clientId: "e289d569-465f-422e-9d8a-885b8d2990e8", // Replace with your Azure AD app's client ID
	    authority: "https://login.microsoftonline.com/common/", // Replace with your Azure AD tenant ID or name
	    redirectUri: "http://localhost:3000", // Replace with your redirect URI configured in Azure AD app
  },
};

const pca = new PublicClientApplication(configuration);

const settings = {
  direction: 'ltr', // or 'rtl' depending on your requirements
  mode: 'light'
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="655987795279-t5i939srv26ivejpjdqbnkkbges7hgms.apps.googleusercontent.com">
        <MsalProvider instance={pca}>
            <App />
        </MsalProvider>
    </GoogleOAuthProvider>
   </React.StrictMode> 
);


reportWebVitals();
